/**
 * @generated SignedSource<<a7a8b9ee08853699037e2fc7825782f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleHeadlineHeaderFeaturesContent$data = {
  readonly headline: string | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly " $fragmentType": "articleHeadlineHeaderFeaturesContent";
};
export type articleHeadlineHeaderFeaturesContent$key = {
  readonly " $data"?: articleHeadlineHeaderFeaturesContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleHeadlineHeaderFeaturesContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "articleHeadlineHeaderFeaturesContent"
};

(node as any).hash = "98026df2778dea447b5442bbafeeb337";

export default node;
